const selectors = {
  selectSaleItem: '판매 주문 선택{{mode}}',
  multiple: ' (다중 선택)',
  single: ' (단일 선택)',
};

export default selectors;